<template>
  <div class="custom-container" v-loading.fullscreen.lock="promo.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="6">
        <div class="promo-title">Create Promo &#38; Voucher</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="ml-4">
        <el-form label-position="left" ref="promo" label-width :model="promo.data">
          <el-col :span="9">
            <h1 class="my-4">Promo Rule</h1>
            <Form :Promo="promo.data"></Form>
          </el-col>
          <el-col :span="3">
            <span>&nbsp;</span>
          </el-col>
          <el-col :span="8" class="mt-4">
            <FormPromo v-if="promo.data.promoType === 'promo_to_item'" :Promo="promo.data"></FormPromo>
            <FormStrata v-else-if="promo.data.promoType === 'strata_disc'" :Promo="promo.data"></FormStrata>
            <FormPaymentToCart
              v-else-if="promo.data.promoType === 'payment_method_to_cart'"
              :Promo="promo.data"
            ></FormPaymentToCart>
            <FormPromoToCart v-else-if="promo.data.promoType === 'promo_to_cart'" :Promo="promo.data"></FormPromoToCart>
            <FormPushToCart v-else-if="promo.data.promoType === 'push_to_cart'" :Promo="promo.data"></FormPushToCart>
            <FormVoucher v-else-if="promo.data.promoType === 'voucher'" :Promo="promo.data"></FormVoucher>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import FormPromo from "./Promo/index";
import FormStrata from "./Strata/index";
import FormPaymentToCart from "./PaymentToCart/index";
import FormPromoToCart from "./PromoToCart/index";
import FormPushToCart from "./PushToCart/index";
import FormVoucher from "./PromoToVoucher/index";
import { mapActions, mapState } from "vuex";
import { formInitPromo } from './formInit';
import _ from 'lodash';

export default {
  components: {
    Form,
    FormPromo,
    FormStrata,
    FormPaymentToCart,
    FormPromoToCart,
    FormPushToCart,
    FormVoucher
  },
  data: () => ({
    valid: true,
    draft: false,
  }),
  computed: {
    ...mapState({
      promo: state => state.promo.promo
    })
  },
  methods: {
    ...mapActions({
      createPromo: "promo/CreatePromo"
    }),
    save() {
      this.$refs.promo.validate(valid => {
        if (valid) {
          this.createPromo(this.promo.data);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.promo.data = _.cloneDeep(formInitPromo)  
  }
};
</script>

<style>
</style>
